import { markRaw } from 'vue';
import { AdminLayout, BlankLayout, PageView } from '@/layouts';

export const ROOT_NAME = -1;

// const modules = getModules();

// 前端路由表
const constantRouterComponents: Common.Params = {
  // 基础页面 layout 必须引入

  // 空白布局
  BlankLayout: markRaw(BlankLayout),
  // 独立页面
  PageView: markRaw(PageView),
  404: () => import('@/views/system/exception/404/index.vue'),

  // 带公共顶部的页面
  adminLayout: markRaw(AdminLayout), // () => import('@/layouts/AdminLayout'),
  // 警情监控
  baseHome: () => import('@/views/base/home'),
};

/**
 * 动态生成菜单
 * @returns
 */
export function generatorDynamicRouter(
  result: UserRes.GetUserMenu[]
): Common.Router[] {
  const routers = generator(result);
  return routers;
}

/**
 * 去除路径中的所有参数
 * @param {string} url - 原始路径和参数
 * @returns {string} 去除参数后的路径
 */
function removeUrlParameters(url: string): string {
  // 查找问号的位置，问号后面是参数部分
  const questionMarkIndex = url.indexOf('?');
  if (questionMarkIndex === -1) {
    // 如果没有问号，返回原始路径
    return url;
  }
  // 截取问号前面的部分，即路径部分
  return url.slice(0, questionMarkIndex);
}

/**
 * 格式化树形结构数据 生成 vue-router 层级路由表
 * @param routerMap
 * @param parent
 * @returns
 */
export const generator = (routerMap: UserRes.GetUserMenu[]) => {
  return routerMap.map((item) => {
    const { component, isHide, key, name, disabled } = item;
    const currentRouter: Common.Router = {
      path: removeUrlParameters(key) || '',
      // 路由名称，建议唯一
      name: `${key}_${name}`,
      // 该路由对应页面的组件
      component: component
        ? (constantRouterComponents[
            component!
          ] as unknown as Common.VueComponent)
        : BlankLayout,

      // meta: 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: {
        title: name,
      },
      // 是否设置了隐藏菜单
      hidden: isHide as boolean,
      children: [],
      redirect: item.children ? item.children[0].key : '', // key === '/policeSituation/systemSetting' ? '/' : undefined,
    };
    // 是否有子菜单，并递归处理
    if (item.children && item.children.length > 0) {
      currentRouter.children = generator(item.children);
    }
    return currentRouter;
  });
};
